<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="lmodel !== null && vmodel !== null">
    <TabView class="page-layout">
      <!-- Settings tab -->
      <TabPanel header="Settings">
        <div>
          <!-- Thank You page  start  -->
          <div class="grid" style="align-items: center">
            <div class="col-12 lg:col-12">
              <h4 class="heading-text">
                {{ lmodel.ambThankYouTitle }}
              </h4>
            </div>
          </div>

          <div class="grid mb-0">
            <div class="col-12 lg:col-12 py-0">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip.top="lmodel.ambThanksScreenHeaderToolTip"
              >
                {{ staticData.settings.header }}
              </label>
              <InputText
                v-model="vmodel1.ambCustomerThanksScreenTitle"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambThanksScreenHeaderPlaceholder"
                class="mt-1"
                id="customerThanksScreenTitle"
              ></InputText>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip.top="lmodel.ambCheckoutWelcomeBodyToolTip"
              >
                {{ lmodel.ambThanksScreenBody }}
              </label>
              <Textarea
                v-model="vmodel1.ambCustomerThanksScreenBody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambThanksScreenBodyPlaceholder"
                class="mt-1 textareaBody"
                id="customerThanksScreenBody"
              ></Textarea>
            </div>
          </div>
          <!-- Thank you page End -->
          <!-- Ambassdor Recall Page start-->
          <div class="grid mt-4">
            <div class="col-12 lg:col-12 py-0">
              <h4 class="heading-text">
                {{ lmodel.ambassadorCodePageTitle }}
              </h4>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip.top="lmodel.ambCouponScreenHeaderToolTip"
              >
                {{ staticData.settings.header }}
              </label>
              <InputText
                v-model="vmodel1.ambCustomerCouponScreenTitle"
                type="text"
                autocomplete="off"
                class="mt-1"
                id="customerThanksScreenTitle"
              ></InputText>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip.top="lmodel.ambCouponScreenTermsToolTip"
              >
                {{ lmodel.ambCouponScreenTerms }}
              </label>
              <Textarea
                v-model="vmodel1.ambCustomerCouponScreenTerms"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                id="customerThanksScreenBody"
              ></Textarea>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip.top="lmodel.ambCouponScreenBodyToolTip"
              >
                {{ lmodel.ambCouponScreenBody }}
              </label>
              <Textarea
                v-model="vmodel1.ambCustomerCouponScreenBody"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                id="customerThanksScreenBody"
              ></Textarea>
            </div>
          </div>
          <!-- Ambassdor Recall Page End-->

          <!-- Reward page start -->
          <div class="grid mt-4">
            <div class="col-12 lg:col-12 py-0">
              <h4 class="heading-text">
                {{ lmodel.ambRewardPage }}
              </h4>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip.top="lmodel.ambRewardpageheaderToolTip"
              >
                {{ staticData.settings.header }}
              </label>
              <InputText
                v-model="vmodel1.ambrewardpageheader"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambRewardpageheaderPlaceholder"
                class="mt-1"
                id="customerThanksScreenTitle"
              ></InputText>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label class="control-label" for="ambThanksScreenHeader-tooltip">
                {{ staticData.settings.rwdpageterms }}
              </label>
              <Textarea
                v-model="rwdpageterms"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                id="customerThanksScreenTitle"
              ></Textarea>
            </div>
          </div>
          <!-- Reward page End -->
          <div class="grid mt-4">
            <div class="col-12 lg:col-12 py-0">
              <h4 class="heading-text">
                {{ lmodel.setDealVoyadoReward }}
              </h4>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label class="control-label" for="ambThanksScreenHeader-tooltip">
                {{ lmodel.setFriCouponExpiredHeader }}
              </label>
              <InputText
                v-model="vmodel1.setCouponExpiredHeader"
                id="friCouponExpiredHeader"
                type="text"
                autocomplete="off"
                class="mt-1"
                :placeholder="lmodel.setFriCouponExpiredHeaderPlaceholder"
              />
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label class="control-label" for="ambThanksScreenHeader-tooltip">
                {{ lmodel.setFriCouponExpiredMessage }}
              </label>
              <Textarea
                v-model="vmodel1.setCouponExpiredMessage"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                :placeholder="lmodel.setFriCouponExpiredMessagePlaceholder"
              />
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.setFriDealExpiredHeaderToolTip"
              >
                {{ lmodel.setFriDealExpiredHeader }}
              </label>
              <InputText
                v-model="vmodel1.setDealExpiredHeader"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1"
                :placeholder="lmodel.setFriDealExpiredHeaderPlaceholder"
              />
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.friDealExpiredMessageToolTip"
              >
                {{ lmodel.setFriDealExpiredMessage }}
              </label>
              <Textarea
                v-model="vmodel1.setDealExpiredMessage"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                :placeholder="lmodel.setFriDealExpiredMessagePlaceholder"
              />
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.setVoyadoRewardUsedTitleToolTip"
              >
                {{ lmodel.setVoyadoRewardUsedTitle }}
              </label>
              <InputText
                v-model="vmodel1.setVoyadorewardusetitle"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1"
                :placeholder="lmodel.setVoyadoRewardUsedTitlePlaceholder"
              />
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.setVoyadoRewardUsedBodyToolTip"
              >
                {{ lmodel.setVoyadoRewardUsedBody }}
              </label>
              <Textarea
                v-model="vmodel1.setVoyadorewardusebody"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                :placeholder="lmodel.setVoyadoRewardUsedBodyPlaceholder"
              />
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.setVoyadoRewardAssignedTitleToolTip"
              >
                {{ lmodel.setVoyadoRewardAssignedTitle }}34
              </label>
              <InputText
                v-model="vmodel1.setVoyadorewardassigntitle"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1"
                :placeholder="lmodel.setVoyadoRewardAssignedTitlePlaceholder"
              />
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.setVoyadoRewardAssignedBodyToolTip"
              >
                {{ lmodel.setVoyadoRewardAssignedBody }}
              </label>
              <Textarea
                v-model="vmodel1.setVoyadorewardassignbody"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                :placeholder="lmodel.setVoyadoRewardAssignedBodyPlaceholder"
              ></Textarea>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.setOtherVoyadoRewardAssignedTitleToolTip"
              >
                {{ lmodel.setOtherVoyadoRewardAssignedTitle }}
              </label>
              <InputText
                v-model="vmodel1.setOtherVoyadorewardassigntitle"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1"
                :placeholder="
                  lmodel.setOtherVoyadoRewardAssignedTitlePlaceholder
                "
              ></InputText>
            </div>
          </div>
          <div class="grid mb-0">
            <div class="col-12 lg:col-12">
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.setOtherVoyadoRewardAssignedBodyToolTip"
              >
                {{ lmodel.setOtherVoyadoRewardAssignedBody }}
              </label>
              <Textarea
                v-model="vmodel1.setOtherVoyadorewardassignbody"
                id="friCouponExpiredMessage"
                type="text"
                autocomplete="off"
                class="mt-1 textareaBody"
                :placeholder="
                  lmodel.setOtherVoyadoRewardAssignedBodyPlaceholder
                "
              ></Textarea>
            </div>
          </div>
          <div class="grid mb-0">
            <!-- Condition base field -->
            <div
              class="col-12 lg:col-12"
              v-show="vmodel.ambAllowexistingmember == false"
            >
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.ambAlreadyMemberHeaderToolTip"
              >
                {{ lmodel.ambAlreadyMemberHeader }}
              </label>
              <InputText
                v-model="vmodel1.ambAlreadymemberheader"
                id="alreadyMemberHeader"
                type="text"
                autocomplete="off"
                class="mt-1"
              ></InputText>
            </div>
          </div>
          <div class="grid mb-0">
            <div
              class="col-12 lg:col-12"
              v-show="vmodel.ambAllowexistingmember == false"
            >
              <label
                class="control-label"
                for="ambThanksScreenHeader-tooltip"
                v-tooltip="lmodel.ambAlreadyMemberTextToolTip"
              >
                {{ lmodel.ambAlreadyMemberText }}
              </label>
              <Textarea
                v-model="vmodel1.ambAlreadymembertext"
                id="alreadyMemberHeaderid"
                type="text"
                autocomplete="off"
                class="mt-1"
              ></Textarea>
            </div>
          </div>
        </div>
      </TabPanel>

      <!-- Styling  -->
      <TabPanel header="Styling" v-if="lmodel !== null && vmodel !== null">
      </TabPanel>
    </TabView>
    <!-- <div class="border-line mt-2"></div> -->
  </div>
</template>

<script>
import staticData from "@/staticdata/static.json";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

export default {
  components: {
    TabView,
    TabPanel,
  },
  props: {
    dealId: {
      type: String,
      default: null,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false,
    },
    modelstate: {
      type: Object,
      default: null,
    },
    selectedDeviceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showInputs: false,
      value: 0,
      staticData: staticData.returnvisit,
      rwdpageterms: "Ambassador terms and conditions text",
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.page-layout {
  margin-top: 180px;
  font-family: "Voyado Text";
}

:deep(.p-tabview .p-tabview-panels) {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}

input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
  resize: none;
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  // border: 1px solid #cedacf;
}

h4 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0;
  font-size: 1.5rem;
}

.control-label {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: normal;
  position: relative;
  vertical-align: top;
}

.header-text span {
  display: block;
  margin-top: 5px;
}

:deep(input) {
  height: 40px;
  width: 395px;
  border-radius: 4px;
  border: 1px solid #c0c0bc;
  padding: 10px;
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
  border: none !important;
  background: #ffffff;
  color: #000000;
  padding: 1rem 1.125rem 0rem;
  font-weight: 400;
  font-size: 14.22px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s, outline-color 0.2s;
  margin: 0 0 -1px 0;
  outline-color: transparent;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  background: #ffffff;
  border: 1px solid #dee2e6 !important;
  border-width: 0px 0px 1px 0px !important;
  color: #000000;
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border: none;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border-bottom: 3px solid #791a3f;
}
:deep(.p-tabview .p-tabview-ink-bar) {
  display: none !important;
}

:deep(.p-button:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}

/* Style for the input field */

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtextcolor {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
  background: #ffffff;
  border: 0 none;
  color: #212529;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.p-inputgroup-addon-radius {
  background: #9b1c45;
  color: #495057;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  padding: 0.5rem 0.75rem;
  height: 40px;
  border-right: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
}

:deep(.p-inputtext, input) {
  width: 100%;
  box-shadow: none;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text" !important;
}

:deep(.heading-text) {
  height: 18px !important;
  font-family: "Voyado Text" !important;
  font-size: 14.22px;
  font-weight: 600 !important;
  line-height: 17.1px;
  text-align: left;
}
:deep(.textareaBody) {
  height: 79px !important;
  .p-inputtextarea {
    height: 79px !important;
  }
}
</style>
